import type { AccountingMapping } from "store/types";

interface ComparisonTableLine {
    line: AccountingMapping;
    exampleNote: string;
    value: number;
}

const ComparisonTableLine = ({ line, exampleNote, value }: ComparisonTableLine) => {
    return (
        <tr>
            <td style={{ borderLeft: "none" }}>
                <span
                    style={{
                        display: "inline-block",
                        width: "130px",
                        marginRight: "1rem",
                    }}
                >
                    {line.accountNumber}
                </span>
                <span>{exampleNote}</span>
            </td>
            <td className="numbers" style={{ color: "rgb(39 90 176 / 80%)" }}>
                {line.direction === "debit" ? value / 100 : ""}
            </td>
            <td
                className="numbers"
                style={{
                    borderRight: "none",
                    color: "rgb(141 136 136)",
                }}
            >
                {line.direction === "credit" ? value / 100 : ""}
            </td>
        </tr>
    );
};

export { ComparisonTableLine };
